import { filter } from 'rxjs/operators/filter';
import { take } from 'rxjs/operators/take';
import { areStringsEquivalent, normalize } from './strings';

/**
 * Returns an Observable of the first field matching the provided string, or an empty Observable if no matching field
 * could be found.
 */
var findField$ = function findField$(jqlFields$, field) {
  return jqlFields$.pipe(filter(function (_ref) {
    var value = _ref.value;
    var normalizedField = normalize(field);
    var normalizedValue = normalize(value);
    return areStringsEquivalent(normalizedField, normalizedValue);
  }), take(1));
};
export default findField$;